import { authRoles } from 'app/auth';
import ValaszTable from 'app/admin/valasz/table/ValaszTable';
import ValaszEditForm from 'app/admin/valasz/editform/ValaszEditForm';

export default [
	{
		path: '/valasz/edit/:id',
		component: ValaszEditForm,
		auth: authRoles.admin
	},
	{
		path: '/valasz/:sessionNameParam?',
		component: ValaszTable,
		auth: authRoles.admin
	}
];
